import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
*/

/* eslint-disable wf-security/no-location-href */
import globals from '../../globals/globals';
import { workingEnd } from 'wfui-digital-core/es/actions';
import { getStore } from '../../store/store';
import { execute } from '../../native-app-bridge/native-app-bridge';
import logger from '../../logger/logger';
var navigationType = 'Browser navigation';
export default (function (navigation) {
  var navigationItem = navigation.navigationItem;
  var url = navigationItem.url,
      forceWindow = navigationItem.forceWindow,
      nativeNavigationType = navigationItem.nativeNavigationType;

  var _globals = globals(),
      _globals$rootContextP = _globals.rootContextPath,
      rootContextPath = _globals$rootContextP === void 0 ? '' : _globals$rootContextP,
      _globals$keepAlivePat = _globals.keepAlivePath,
      keepAlivePath = _globals$keepAlivePat === void 0 ? 'keepAlive' : _globals$keepAlivePat;

  logger.debug("".concat(navigationType, ": Starting"));
  logger.debug("".concat(navigationType, ": ").concat(url));
  getStore().dispatch(workingEnd());

  if (globals().nativeWrapped) {
    var type = nativeNavigationType || globals().defaultExternalType || 'externalnoconfirm';
    var payload = {
      url: url,
      type: type,
      keepAliveUrl: window.location.origin + rootContextPath + keepAlivePath + '?F=J'
    };
    return execute('openUrl', payload);
  } else {
    if (forceWindow) {
      logger.debug("".concat(navigationType, ": Calling window.open"));
      window.open(url);
    } else {
      logger.debug("".concat(navigationType, ": Setting window location"));
      window.location = url;
    }

    return Promise.resolve(navigation);
  }
});